import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Button from '@atlaskit/button';
import { LinkIconButton } from '@atlaskit/button/new';
import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import LegacyQuestionIcon from '@atlaskit/icon/glyph/question';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import { N0 } from '@atlaskit/theme/colors';
import { SyntaxHelpContainer } from './styled';

// Fixes icon margin issus after new icon migration
var iconStyle = xcss({
  margin: 'space.025',
  display: 'inline-flex'
});
export var BaseSyntaxHelp = function BaseSyntaxHelp(_ref) {
  var describedby = _ref.describedby,
    isDisabled = _ref.isDisabled,
    label = _ref.label,
    onClick = _ref.onClick;
  return fg('platform-component-visual-refresh') ? /*#__PURE__*/React.createElement(LinkIconButton, {
    "aria-describedby": describedby,
    label: label,
    isDisabled: isDisabled,
    appearance: "subtle",
    spacing: "compact",
    onClick: onClick,
    target: "blank",
    href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
    icon: function icon(iconProps) {
      return /*#__PURE__*/React.createElement(QuestionCircleIcon, _extends({}, iconProps, {
        color: "var(--ds-icon-subtle, #626F86)"
      }));
    }
  }) : /*#__PURE__*/React.createElement(SyntaxHelpContainer, null, /*#__PURE__*/React.createElement(Button, {
    "aria-describedby": describedby,
    "aria-label": label,
    isDisabled: isDisabled,
    appearance: 'subtle',
    spacing: 'none',
    target: 'blank',
    href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
    iconBefore: /*#__PURE__*/React.createElement(Box, {
      xcss: iconStyle
    }, /*#__PURE__*/React.createElement(QuestionCircleIcon, {
      label: '',
      color: isDisabled ? "var(--ds-icon-disabled, ".concat(N0, ")") : "var(--ds-icon-inverse, ".concat(N0, ")"),
      LEGACY_size: 'small',
      LEGACY_fallbackIcon: LegacyQuestionIcon,
      LEGACY_margin: "-2px"
    })),
    onClick: onClick
  }));
};